import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SapPostingKeyService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SapPostingKeyCreateDto,
  SapPostingKeyDto,
  SapPostingKeyExcelDownloadDto,
  SapPostingKeyUpdateDto,
} from '../proxy/controlling/dtos/sap-posting-key';
import { SAPPOSTINGKEY_CONFIG, SAPPOSTINGKEY_FIELDS } from './sap-posting-key.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sap-posting-key',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SapPostingKeyService, ConfirmationService],
  templateUrl: './sap-posting-key.html',
  styleUrl: './sap-posting-key.scss',
})
export class SapPostingKey extends BaseHierarchicalCrudComponent<
  SapPostingKeyDto,
  SapPostingKeyCreateDto,
  SapPostingKeyUpdateDto,
  SapPostingKeyExcelDownloadDto
> {
  service = inject(SapPostingKeyService);
  config = SAPPOSTINGKEY_CONFIG;
  fields = SAPPOSTINGKEY_FIELDS;

  protected prepareUpdateDto(data: any, selected: SapPostingKeyDto): SapPostingKeyUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SapPostingKey';
  }
}
